import type { FhVitalsResult } from './fh-vitals-types'

/**
 * FHVitalsSDK 5.9.3 emits partial `on_result` frames for many seconds before a full set (task
 * brief; faceheart2.html). A frame is usable once at least 3 of its 5 vitals are present and
 * positive — the exact rule faceheart2.html uses — and the scan keeps the most recent usable frame
 * rather than waiting for a perfect one, because a perfect one may never arrive before the 55s
 * window closes.
 */
export function isUsableResult(result: FhVitalsResult): boolean {
  const values = [result.hr, result.sbp, result.dbp, result.spo2, result.rr]
  return values.filter((value): value is number => typeof value === 'number' && value > 0).length >= 3
}

/** Pure so the "keep the latest usable frame" rule is provable without a running SDK session. */
export function pickBestResult(
  previous: FhVitalsResult | null,
  incoming: FhVitalsResult,
): FhVitalsResult | null {
  return isUsableResult(incoming) ? incoming : previous
}
